export default "__VITE_ASSET__BWSirlA6__"